import axios, { CancelTokenSource } from 'axios';

export const GetSchedulerGant = (cond: string) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`order?where=` + cond;
  return axios.get(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
  });
};

export const GetSchedulerKPI = (cond: string) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`gant/kpi?where=` + cond;
  return axios.get(query);
};
export const GetGanttSettings = (cond: string) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`gant/settings?where=` + cond;
  return axios.get(query);
};
export const EditGanttSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`gant/settings/update`, obj, {
    headers,
  });
};
export const GetSchedulerLoad = (cond: string) => {
  var query =
    process.env.REACT_APP_API_GLOBAL_URL+`gant/load-and-capacity?where=` + cond;
  return fetch(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
  });
};
export const GetPlanOrderGant = (
  cond: string,
  tokenSource?: CancelTokenSource
) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`gant?where=` + cond;
  return axios.get(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
    cancelToken: tokenSource?.token,
  });
};
export const GetKanbanColor = (cond: string) => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`priority?where=` + cond);
};
export const GetKanBanGraph = (cond: string) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`kanban/graphdata?where=` + cond;
  return axios.get(query);
};
export const GetOrderDetail = (cond: string) => {
  var query =
    process.env.REACT_APP_API_GLOBAL_URL+`kanban/countOfStatus?where=` + cond;
  return axios.get(query);
};

export const EditWorkOrder = (obj: Object, timezoneOffset?:number) => {
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  if(ERP_TYPE === 'PRONTO'){
    timezoneOffset = 0;
  }
  const headers = {
    'Content-Type': 'application/json',
  };
  //      let theUrl = process.env.REACT_APP_API_GLOBAL_URL + `${edit_query}`+`/${timezoneOffset}`;

  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`order/edit`+`/${timezoneOffset}`, obj, {
    headers,
  });
};
export const GetMaxProntoRowIdData = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`mex-order/max-pronto-row-id`)
};

export const EditKanbanColor = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`priority/edit`, obj, {
    headers,
  });
};
export const DeleteKanbanColor = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`priority/delete`, obj, {
    headers,
  });
};
